import React from "react";
import { createRoot } from "react-dom/client";
import DataPermissionsMatrixIsland from "./DataPermissionsMatrixIsland";

const mountNode = document.getElementById("data-permissions-matrix-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<DataPermissionsMatrixIsland config={config} />);
  }
}
